import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuthToken } from "../../../utils/authToken";
import { isFranchisePortalSession } from "../../../utils/franchiseSession";
import config from "../../../../config.json";

const API = import.meta.env.VITE_REACT_APP_BACKEND_URL || config.dev;

export default function SubscriptionGate({ children }) {
  const location = useLocation();
  const [mustBuy, setMustBuy] = useState(false);
  const franchisePortal = isFranchisePortalSession();

  useEffect(() => {
    if (franchisePortal) return undefined;
    let ignore = false;
    (async () => {
      try {
        const response = await fetch(`${API}/billing/plan/status`, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        if (!response.ok) return;
        const data = await response.json();
        if (!ignore) setMustBuy(Boolean(data.mustBuy));
      } catch {
        /* keep the backoffice usable if billing status cannot be loaded */
      }
    })();
    return () => {
      ignore = true;
    };
  }, [franchisePortal, location.pathname]);

  const onPlans = location.pathname.replace(/\/+$/, "") === "/plans";
  if (!franchisePortal && mustBuy && !onPlans) {
    return <Navigate to="/plans" replace />;
  }

  return children;
}
